import React from "react";

export const REPORT_YEAR_MIN = 1990;
export const REPORT_YEAR_MAX = 2100;

function normalizeYearInput(raw) {
  const digits = String(raw ?? "").replace(/\D/g, "").slice(0, 4);
  if (!digits) return "";
  const n = parseInt(digits, 10);
  if (!Number.isFinite(n)) return "";
  if (n < REPORT_YEAR_MIN || n > REPORT_YEAR_MAX) return String(n);
  return String(n);
}

/**
 * Year-only input. Accepts exactly a 4-digit year.
 */
const ReportYearCalendarInput = ({
  id,
  label,
  labelClassName = "block text-xs font-medium text-gray-600 mb-1",
  yearValue,
  onYearChange,
  inputClassName,
  disabled = false,
}) => {
  return (
    <div>
      {label && (
        <label htmlFor={id} className={labelClassName}>
          {label}
        </label>
      )}
      <input
        id={id}
        type="text"
        inputMode="numeric"
        pattern="\d{4}"
        placeholder="YYYY"
        value={yearValue || ""}
        onChange={(e) => onYearChange(normalizeYearInput(e.target.value))}
        disabled={disabled}
        maxLength={4}
        className={inputClassName}
      />
    </div>
  );
};

export default ReportYearCalendarInput;
